export default __webpack_public_path__ + "static/media/arrowDarkGrey.f38b160b.svg";